export class ResetPasswordVO {
  constructor(
    public userId?: number,
    public tempPassword?: any,
    public password?: any,
    public verficationCode?: boolean,
    public tempPasswordSw?: string,
    public currentPassword?: any,
    public currentPasswordSw?: boolean,
    public lastSixPassSW?: boolean,
    public tempPasswordExpired?: boolean,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/ResetPasswordVO.ts